import Button from 'components/shared/Button';

import s from './index.module.css';

type Props = {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmationModal(props: Props) {
  return (
    <div className={s.head}>
      <div className={s.title}>{props.message}</div>
      <div className={s.actions}>
        <Button autoFocus type="default" onClick={props.onCancel}>
          No
        </Button>
        <Button onClick={props.onConfirm}>Yes</Button>
      </div>
    </div>
  );
}
